import http from '../../baseUrl/HttpCommon';
import authHeader from '../authHeader/AuthHeader';

const getPaymentMethods = () => {
  return http.get(`/Payment/GetPaymentMethods`, {
    headers: authHeader()
  });
};

const getPaymentGateways = () => {
  return http.get(`/Payment/GetPaymentGateways`, {
    headers: authHeader()
  });
};

const getSurchargeRules = (payload = {}) => {
  return http.post(`/Payment/GetSurchargeRules`, payload, {
    headers: authHeader()
  });
};

const getSurchargeRuleById = (id) => {
  return http.get(`/Payment/GetSurchargeRuleById?id=${id}`, {
    headers: authHeader()
  });
};

const saveSurchargeRule = (data) => {
  return http.post(`/Payment/SaveSurchargeRule`, data, {
    headers: authHeader()
  });
};

const deleteSurchargeRule = (id) => {
  return http.post(`/Payment/DeleteSurchargeRule?id=${id}`, {}, {
    headers: authHeader()
  });
};

const SurchargeRuleService = {
  getPaymentMethods,
  getPaymentGateways,
  getSurchargeRules,
  getSurchargeRuleById,
  saveSurchargeRule,
  deleteSurchargeRule
};

export default SurchargeRuleService;
